import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import runIcon from './run.svg';
import bindAll from 'lodash.bindall';
import styles from '../gui/gui.css';
import {connect} from 'react-redux';
import {setGuiTovm} from '../../reducers/code';
import VM from 'scratch-vm';
const btnGroupStyle = {
    display: 'flex',
    WebkitBoxOrient: 'horizontal',
    WebkitBoxDirection: 'normal',
    WebkitFlexDirection: 'row',
    msFlexDirection: 'row',
    flexDirection: 'row',
    position: 'absolute',
    right: 0
};
const btnTextStyle = {marginLeft: '-5px'};
class CodeBox extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleExtensionAdded',
            'runHandler'
        ]);
        this.state = {
            isHandpy: false
        };
    }
    componentDidMount () {
        this.handleExtensionAdded();
        this.props.vm.addListener('EXTENSION_ADDED', this.handleExtensionAdded);
    }
    componentWillUnmount () {
        // this.props.vm.removeListener('EXTENSION_ADDED', this.handleExtensionAdded);
    }

    handleExtensionAdded () {
        const blockInfo = this.props.vm.runtime._blockInfo;
        let isHandpy = false;
        for (let i = 0; i < blockInfo.length; i++) {
            const el = blockInfo[i];
            if (el.id == 'handpy') {
                isHandpy = true;
                break;
            }
        }
        this.setState({isHandpy});
    }
    runHandler () {
        const {socket, code, guiTovm, setGuiTovm} = this.props;
        setGuiTovm({
            state: !guiTovm.state,
            method: 'runCodeFn', // runCodeFn brushCodeFn
            data: code
        })
    }
    render () {
        const {code} = this.props;
        const {isHandpy} = this.state;
        return (
            <React.Fragment>
                <Box className={styles.codeHeaderWrapper}>
                    代码
                    {isHandpy && (
                        // disabled,
                        // iconClassName,
                        // iconSrc,
                        // title
                        // key="retake-button"
                        // aria-label={mainTitle}
                        // className={classNames(styles.button, styles.mainButton)}
                        // data-for={this.mainTooltipId}
                        // data-tip={mainTitle}
                        // ref={this.setButtonRef}
                        // onClick={this.clickDelayer(onClick)}
                        <div style={{...btnGroupStyle}}>
                            <Button
                                iconSrc={runIcon}
                                onClick={this.runHandler}
                            >
                                <span style={{...btnTextStyle}}>运行</span>
                            </Button>
                        </div>
                        
                    )}
                </Box>
                <Box
                    className={styles.codeWrapper}
                >
                    <pre>{code}</pre>
                    <br />
                </Box>
            </React.Fragment>
        );
    }
}

CodeBox.propTypes = {
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    vm: state.scratchGui.vm,
    socket: state.scratchGui.code.socket,
    code: state.scratchGui.code.code,
    guiTovm: state.scratchGui.code.guiTovm,
});

const mapDispatchToProps = dispatch => ({
    setGuiTovm: (guiTovm) => {
        dispatch(setGuiTovm(guiTovm))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CodeBox);
